instaSlider = () => {
    $.ajax({
        type: 'GET',
        url: 'https://www.juicer.io/api/feeds/alieljewellers/',
        data: {get_param: 'value'},
        dataType: 'json',
        success: (data) => {
            let allPosts = data.posts.items
            $.each(allPosts, (index) => {        
            const url = allPosts[index].full_url;
            const image = allPosts[index].image;
            const contentString = `<div class="swiper-slide">
                    <a target="_blank" class="insta-card-img card-img-large image-scale" href="${url}">
                        <img
                        src="${image}"
                        height=""
                        width="">
                    </a>
                    </div>  `;   
            $('.instaSlider .swiper-wrapper').append(contentString);
        });
        },
    });

};

instaSlider();